import React from "react";
import Header from "../../../Components/Header";
import RejectionListComp from "../../../Components/OMS/RejectionListComp/RejectionListComp";
import SingleSignOnSideBar from "../../../Components/SingleSignOnSideBar";
import { OMSHNI } from "../../../Configuration/Telecaller_URl";

function RejectionListOmsHni() {
  const storeToken = localStorage.getItem("ssoToken");
  if (storeToken == null) {
    window.location.replace("/");
  }

  return (
    <>
      <Header portal={"TELECALLER"} />
      <SingleSignOnSideBar />
      <main id="main-content">
        <div className="omspage">
          <div className="card-box">
            <RejectionListComp
              URL={OMSHNI.REJECTION_CUSTOMER_HNI_URL}
              mainType={"HNI"}
            />
          </div>
        </div>
      </main>
    </>
  );
}

export default RejectionListOmsHni;
